import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COUNTRIES_ITEM: {},
  COUNTRIES_LIST: [],
  COUNTRIES_TABLE_DATA: [],
  COUNTRIES_LIST_DATA: [],
  COUNTRIES_TOTAL_ROWS: 0
}

export const getters = {
  GET_COUNTRIES_ITEM: (state) => {
    return state.COUNTRIES_ITEM;
  },
  GET_COUNTRIES_LIST_DATA: (state) => {
    return state.COUNTRIES_LIST_DATA;
  },
  GET_COUNTRIES_TABLE_DATA: (state) => {
    return state.COUNTRIES_TABLE_DATA;
  },
  GET_COUNTRIES_TOTAL_ROWS: (state) => {
    return state.COUNTRIES_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_COUNTRIES_ITEM(state, item) {
    state.COUNTRIES_ITEM = item;
  },
  UPDATE_COUNTRIES_LIST(state, list) {

    state.COUNTRIES_LIST = list.data;
    state.COUNTRIES_TOTAL_ROWS = list.total;

    list = list.data;

    state.COUNTRIES_TABLE_DATA = [];
    state.COUNTRIES_LIST_DATA = [];

    list.forEach(el => {

      state.COUNTRIES_TABLE_DATA.push({
        'id'  : el.id ? el.id : null,
        'uuid': el.uuid ? el.uuid : null,
        'name': el.name ? el.name : null,
        'code': el.code ? el.code : null,
      });

      state.COUNTRIES_LIST_DATA.push({
        'id'  : el.id   ? el.id   : null,
        'uuid': el.uuid ? el.uuid : null,
        'name': el.name ? el.name : null,
        'code': el.code ? el.code : null,
      });

    });
  },
}


export const actions = {

  async FETCH_COUNTRIES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/countries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COUNTRIES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_COUNTRIES_LIST({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/countries';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COUNTRIES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_COUNTRIES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/countries';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_COUNTRIES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/countries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_COUNTRIES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/countries/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}